import { FC, useState } from "react";
import { MenuIconWrapper } from "./MenuIcon.style";

type IMenuIconProps = {
  onClick: () => void;
};

export const MenuIcon: FC<IMenuIconProps> = ({ onClick }) => {
  const [isCross, setIsCross] = useState(false);
  const [hasClicked, setHasClicked] = useState(false);

  const handleClick = () => {
    setIsCross(!isCross);
    setHasClicked(true);
    onClick();
  };

  return (
    <MenuIconWrapper
      className={`menu-icon-container 
        ${hasClicked ? (isCross ? "transform-to-cross" : "transform-to-lines") : ""}
        `}
      onClick={handleClick}
    >
      <div className="menu-icon-top"></div>
      <div className="menu-icon-middle">
        <div className="menu-icon-middle-inner"></div>
      </div>
      <div className="menu-icon-bottom"></div>
    </MenuIconWrapper>
  );
};
